// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__X7e39","item":"PaymentsMobile_item__3LHLh","label":"PaymentsMobile_label__1eryF","amount":"PaymentsMobile_amount__2Icyu"};